import * as R from 'ramda'
import React, { useContext, Fragment } from 'react'
import SEO from './shared/seo'
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';


import { useWindowResize } from '../util/hooks'
import OperationLayout from './operation'
import PublicLayout from './open'
import LoadingBar from './shared/loadingBar'
import { GlobalContext } from '../context/globalContext'
import ErrorBoundary from './shared/errorBoundary'

const Layout = props => {
    useWindowResize()
    const { title, keywords, layout, layoutMode, children } = props

    const globalContext = useContext(GlobalContext)
    const { loginInfo, getLayoutMode, setLayoutMode } = globalContext

    const layoutModeValue = 'public'
    const menu = []
    const content = <ErrorBoundary>{children}</ErrorBoundary>

    return R.cond([
        [
            () => !layout,
            () => (
                <Fragment>
                    <SEO keywords={keywords} title={title} />
                    <LoadingBar position={0} />
                    {content}
                </Fragment>
            ),
        ],
        [
            () => layoutModeValue === 'operation',
            () => (
                <OperationLayout {...props} menu={menu}>
                    <SEO keywords={keywords} title={title} />
                    {children}
                </OperationLayout>
            ),
        ],
        [
            () => layoutModeValue === 'public',
            () => (
                <PublicLayout {...props} menu={menu}>
                    <SEO keywords={keywords} title={title} />
                    {children}
                </PublicLayout>
            ),
        ],
        [
            R.T,
            () => (
                <Fragment>
                    <SEO keywords={keywords} title={title} />
                    <LoadingBar position={0} />
                    {content}
                </Fragment>
            ),
        ],
    ])()
}

export default Layout
